import React from "react";
import { Breath, Footer, Mistake } from "../components";

const Refund = () => {
  return (
    <>
      <Mistake />
      <Breath />
      <Footer />
    </>
  );
};

export default Refund;
